import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; 

import Home from "../pages/landing/Home";
import Services from "../pages/services/Services";
import ServiceRequests from "../pages/service-requests/ServiceRequests";
import ServiceRequestDetailPage from "../pages/service-requests/ServiceRequestDetailPage";
import ProfileEntry from "../pages/profile/ProfileEntry";
import FreelancerProfileEntry from "../pages/freelancer-profile/FreelancerProfileEntry";
import Projects from "../pages/projects/Projects";
import ProjectDetail from "../pages/projects/ProjectsDetail";
import Notifications from "../pages/notifications/Notifications";
import CreateProjectPage from "../components/panels/CreateProjectPage";
import FreelancerDashboard from "../pages/freelancer-dashboard/FreelancerDashboard";
import BusinessProfileEntry from "../pages/business-profile/BusinessProfileEntry";
import BusinessDashboard from "../pages/business-dashboard/BusinessDashboard"
import MyRequests from "../pages/my-service-requests/MyRequests";
import RequestDetails from "../pages/my-service-requests/RequestDetails";
import ContactForms from "../components/dashboard/ContactForms";

const DashboardRoutes = () => {
  const { role } = useAuth();

  // Absolute paths for Navigate
  const roleHome =
    role === "freelancer"
      ? "/home/freelancer-home"
      : role === "business"
      ? "/home/business-home"
      : "/home";

  return (
    <Routes>
      {/* User home */}
      {role === "user" && <Route path="/" element={<Home />} />}

      {/* Freelancer home */}
      {role === "freelancer" && <Route path="freelancer-home" element={<Home />} />}
      {role === "freelancer" && <Route path="freelancer-dashboard" element={<FreelancerDashboard />} />}

      {/* Business home */}
      {role === "business" && <Route path="business-home" element={<Home />} />}
      {role === "business" && <Route path="business-dashboard" element={<BusinessDashboard />} />}

      {/* Shared */}
      <Route path="my-requests" element={<MyRequests />} />
      <Route path="my-requests/:id" element={<RequestDetails />} />
      <Route path="projects" element={<Projects />} />
      <Route path="projects/:id" element={<ProjectDetail />} />
      <Route path="mailbox" element={<ContactForms />} />
      <Route path="notifications" element={<Notifications />} />
      <Route path="projects/create" element={<CreateProjectPage />} />

      {/* Catch-all → absolute role home */}
      <Route path="*" element={<Navigate to={roleHome} replace />} />
    </Routes>
  );
};

export default DashboardRoutes;